var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{staticClass:"mb-base",attrs:{"title":"Statistique"}},[_c('div',{staticClass:"mt-5"},[_c('chartjs-component-bar-chart',{attrs:{"height":150}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }